"use strict";Object.defineProperty(exports, "__esModule", {value: true});// src/tab.ts
var _tab = require('@ariakit/react-core/tab/tab');
var _tabcontext = require('@ariakit/react-core/tab/tab-context');
var _tablist = require('@ariakit/react-core/tab/tab-list');
var _tabpanel = require('@ariakit/react-core/tab/tab-panel');
var _tabprovider = require('@ariakit/react-core/tab/tab-provider');
var _tabstore = require('@ariakit/react-core/tab/tab-store');








exports.Tab = _tab.Tab; exports.useTabContext = _tabcontext.useTabContext; exports.TabList = _tablist.TabList; exports.TabPanel = _tabpanel.TabPanel; exports.TabProvider = _tabprovider.TabProvider; exports.useTabStore = _tabstore.useTabStore;
